import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
 throw new Error('Missing Supabase environment variables');
}

// Use Supabase defaults (detectSessionInUrl: true, persistSession: true are default)
// This matches player-web's working configuration
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
